import { forwardRef, type Ref, type ReactNode, type HTMLAttributes } from 'react';

export interface AppShellAsideProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  withBorder?: boolean;
}

/** Right-hand sidebar (typically used for inspectors / details panels). */
export const AppShellAside = forwardRef(function AppShellAside(
  { children, withBorder = true, className, ...rest }: AppShellAsideProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <aside
      ref={ref}
      className={[
        'rr-app-shell__aside',
        withBorder && 'rr-app-shell__aside--bordered',
        className
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </aside>
  );
});
AppShellAside.displayName = 'AppShellAside';
